const { VUE_APP_XDB: XDB } = process.env;
const { VUE_APP_BOSS: BOSS } = process.env;
const list = [
  {
    title: '整体软装',
    href: '',
  },
  {
    title: '优选商城',
    href: `${XDB}/pin/home/index`,
  },
  {
    title: '兔狗设计',
    href: `${XDB}/jia/home/index`,
  },
  {
    title: '兔狗到店',
    href: `${XDB}/daodian/home/index`,
  },
  {
    title: '兔狗优选',
    href: `${XDB}/dian/home/index`,
  },
  {
    title: '家装节',
    href: `${XDB}/tuan/home/index`,
  },
  {
    title: '口碑家装',
    href: `${XDB}/ju/index/`,
  },
  {
    title: '验房监理',
    href: `${XDB}/jian/index`,
  },
  {
    title: '装修金融',
    href: `${XDB}/loan/index/`,
  },
  {
    title: '商家云店',
    href: `${XDB}/shang/index/`,
  },
  {
    title: '用户管理',
    href: `${XDB}/profile/account/list/`,
  },
  {
    title: '积分商城',
    href: `${XDB}/credit_mall/ware/list`,
  },
  {
    title: '线上运营',
    href: `${XDB}/index.php?controller=index&act=index`,
  },
  {
    title: '混沌大学',
    href: `${BOSS}/hundun/index`,
  },
  {
    title: '小程序',
    href: `${XDB}/dati/index/index/index`,
  },
  {
    title: '业务系统',
    href: `http://wzxcrm.citytogo.cn`,
  },
  {
    title: '系统管理',
    href: `${XDB}/auth/index`,
  },
  {
    title: '权限管理',
    href: `${BOSS}/limit/index`,
  },
];

export default list;
